module.exports = __webpack_public_path__ + "static/media/BadgeiOS.8d94a6e9.png";